"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const AddOriginalPublisher_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddOriginalPublisher"));
const AddAdministratorPublisher_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddAdministratorPublisher"));
const EditSimpleOriginalPublisher_1 = __importDefault(require("@Components/WorkRegistrationSubs/EditSimpleOriginalPublisher"));
const contexts_1 = require("@App/contexts");
const AddPublishersArea_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/AddPublishersArea"));
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const WriterSideBar_1 = __importDefault(require("@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardAddWriters/WriterSideBar"));
const PublisherRemainingShareCount_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/PublisherRemainingShareCount"));
const OverclaimWarningStep_1 = __importDefault(require("@Components/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep"));
const is_overclaim_allowed_1 = require("@App/helpers/is-overclaim-allowed");
const PublishersStep = ({ workType }) => {
    const { workStore, popupStore, publisherStepStore, wizardFlowStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    const sidebarState = popupStore.publisherSidebarState;
    if (!workDraftFromLocal) {
        return null;
    }
    const editingOP = publisherStepStore.editingOP;
    return (react_1.default.createElement("div", { className: "publishers-step" },
        react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Add Publishers & Shares', title: workDraftFromLocal.title }, "Enter your publisher(s)/administrator(s)."),
        workType === 'claim-wizard' && !(0, is_overclaim_allowed_1.isOverclaimAllowed)(workStore.workDraftLocal) && (react_1.default.createElement(PublisherRemainingShareCount_1.default, null)),
        react_1.default.createElement("div", { className: "publishers-cards-wrapper" },
            react_1.default.createElement(AddPublishersArea_1.default, null)),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: workStore.overclaimWarningOpen },
            react_1.default.createElement(OverclaimWarningStep_1.default, { onClickConfirm: () => {
                    workStore.setOverclaimWarningOpen(false);
                    wizardFlowStore.advanceIndex();
                }, onClickCancel: () => workStore.setOverclaimWarningOpen(false) })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarState !== publisher_side_bar_state_1.PublisherSideBarState.empty, onClose: () => popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty) },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty) },
                sidebarState === publisher_side_bar_state_1.PublisherSideBarState.addOP ? react_1.default.createElement(AddOriginalPublisher_1.default, null) : null,
                sidebarState === publisher_side_bar_state_1.PublisherSideBarState.addAP ? react_1.default.createElement(AddAdministratorPublisher_1.default, null) : null,
                sidebarState === publisher_side_bar_state_1.PublisherSideBarState.editOP ? react_1.default.createElement(EditSimpleOriginalPublisher_1.default, null) : null,
                sidebarState === publisher_side_bar_state_1.PublisherSideBarState.addWriterOp ? react_1.default.createElement(WriterSideBar_1.default, { data: editingOP }) : null))));
};
exports.default = (0, mobx_react_1.observer)(PublishersStep);
